module.exports = __webpack_public_path__ + "static/media/correct-your-data.9dfc238f.png";